import adminStore from '@/modules/admin/store';
import authStore from '@/modules/auth/store';
import dashboardStore from '@/modules/dashboard/store';
import journeysStore from '@/modules/journeys/store';
import maintenanceStore from '@/modules/maintenance/store';
import candidateStore from './collections/candidate/candidate.store';
import countryStore from './collections/country/country.store';
import favorite from './collections/favorite/favorite.store';
import headerStore from './collections/header/header.store';
import permission from './collections/permissions/permission.store';
import submission from './collections/submission/submission.store';
import userInfo from './collections/userInfo/user-info.store';

import { createStore } from 'vuex';
import ModuleTypeService from './services/moduleType';
var moduleTypeService = new ModuleTypeService();

// Vue.use(Vuex);

export default createStore({
   state: {
      history: [],
      moduleTypes: [],
      notifications: [],
      fontSize: +(localStorage.getItem('fontSize') || 13),
      isDev: !['acc', 'prod', 'release'].includes(import.meta.env.VITE_APP_ENV),
   },
   getters: {
      moduleTypes: (state) => {
         return state.moduleTypes;
      },
      getModuleTypeByName: (state) => (key: any) => {
         return state.moduleTypes.find((moduleType: any) => moduleType.key == key);
      },
   },
   mutations: {
      setModuleTypes(state, moduleTypes) {
         state.moduleTypes = moduleTypes;
      },
      pushNotification(state: any, notification) {
         state.notifications.push(notification);
      },
      removeNotification(state: any, notification_key) {
         state.notifications = state.notifications.filter((notification: any) => {
            return notification.key != notification_key;
         });
      },
   },
   actions: {
      async setModuleTypes(context) {
         await moduleTypeService.getModuleTypes().then((response) => {
            context.commit('setModuleTypes', response);
         });
      },
      async addNotification(context, { notification }) {
         let newNotification = {
            ...notification,
            timeout: notification.duration || 5000,
            key: (Math.random().toString(36) + Date.now().toString(36)).substr(2),
         };
         context.commit('pushNotification', newNotification);
         return newNotification;
      },
      async removeNotification(context, { notification_key }) {
         context.commit('removeNotification', notification_key);
      },
   },
   modules: {
      countryStore,
      adminStore,
      authStore,
      dashboardStore,
      journeysStore,
      submission,
      maintenanceStore,
      headerStore,
      userInfo,
      candidateStore,
      permission,
      favorite,
   },
});
